import "../../style/regearStyle.scss";
import React from "react";
import useRegearLogic from "./regearLogic";

function Regear() {
  const {
    submitDeathId,
    setDeathId,
    setResponse,
    deathId,
    isLoading,
    response,
    responseMessage,
  } = useRegearLogic();
  return (
    <div className="regear">
      <div className="regearContainer">
        <div className="regearTitle">
          <p>Game Over</p>
        </div>

        <input
          onClick={() => {
            setResponse("hidden");
          }}
          onChange={(e) => {
            setDeathId(e.target.value.replace(/\s/g, ''));
          }}
          value={deathId}
          className={`regearInput`}
          placeholder=" Enter your death id..."
        ></input>
        <button
          onClick={() => {
            submitDeathId(deathId);
          }}
          className={`regearButton ${deathId === "" && "disable"}`}
        >
          Continue?
        </button>

        <div className={`regearStatus`}>
          <div className={`loading ${isLoading ? "" : "hidden"}`}>
            <p>Loading</p>
          </div>
          <div className={`regearResponse ${response}`}>
            {response === "accepted" ? (
              <p className="accepted">ACCEPTED</p>
            ) : (
              <p className="denied">DENIED</p>
            )}
            <p className={`regearResponseMessage ${response === "accepted" && 'hidden'}`}>{responseMessage}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Regear;
